import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { signOut, getAuth } from "firebase/auth";
import { Layout, Alert, Loader } from "../components";
import * as API from "../http/api";

export type ChangeAlertCallbackType = (flag: boolean, type: string, message: string) => void;
export type ChangeLoaderCallbackType = (flag: boolean) => void;
export type ChangeWidgetsCallbackType = (data: [{ type: string; data?: string }]) => void;

const Root = (props) => {
    const history = useHistory();
    const [loader, setLoader] = useState(false);
    const [alert, setAlert] = useState(false);
    const [typeAlert, setTypeAlert] = useState("");
    const [contentAlert, setContentAlert] = useState("");
    const [showMenu, setShowMenu] = useState(false);
    const [showSideBar, setShowSideBar] = useState(false);
    const [rolName, setRolName] = useState("");
    const [secondaryMenu, setSecondaryMenu] = useState([]);
    const [openMainMenu, setOpenMainMenu] = useState(false);

    useEffect(() => {
        session();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const changeRolName = (data) => {
        setRolName(data);
    };

    const changeSecondaryMenu = (data) => {
        setSecondaryMenu(JSON.parse(JSON.stringify(data)));
    };

    const session = async () => {
        setLoader(true);
        if (!localStorage.session) {
            history.push("/login");
        } else {
            let auth = await API.auth(props.pos);
            if (auth?.status !== 200) {
                let authFirebase = getAuth();
                await signOut(authFirebase)
                    .then(() => {
                        return true;
                    })
                    .catch((error) => {
                        console.log('Error signOut ', error);
                        return false;
                    });

                delete localStorage.session;
                history.push("/login");
            } else {
                let info = JSON.parse(localStorage.session);
                info["token"] = auth.data.token;
                localStorage.session = JSON.stringify(info);
            }

            setLoader(false);
        }
    };

    const changeLoader = (flag) => {
        setLoader(flag);
        const lightbox = document.getElementById("lightbox");
        if (flag) {
            lightbox.classList.add("lightbox-loading");
        } else {
            lightbox.classList.remove("lightbox-loading");
        }
    };

    const changeAlert = (flag, type, message) => {
        setTypeAlert(type);
        setAlert(flag);
        setContentAlert(message);
    };

    const openMenu = () => {
        setShowMenu(true);
    };
    const closeMenu = () => {
        setShowMenu(false);
    };

    const openSideBar = () => {
        setShowSideBar(true);
        setOpenMainMenu(false);
    };
    const closeSideBar = () => {
        setShowSideBar(false);
    };

    const mainMenu = () => {
        return openMainMenu ? setOpenMainMenu(false) : setOpenMainMenu(true);
    };

    return (
        <>
            {loader && <Loader />}
		    <div>
                <Layout
                    pos={props.pos}
                    changeAlert={changeAlert}
                    changeLoader={changeLoader}
                    loader={loader}
                    rolName={rolName}
                    openMenu={openMenu}
                    openMainMenu={openMainMenu}
                    mainMenu={mainMenu}
                    closeMenu={closeMenu}
                    showSecondary={showMenu}
                    openSideBar={openSideBar}
                    showSideBar={showSideBar}
                    closeSideBar={closeSideBar}
                    changeRolName={changeRolName}
                    secondaryMenu={secondaryMenu}
                    changeSecondaryMenu={changeSecondaryMenu}
                />
            </div>
            {alert && (
                <Alert
                    type={typeAlert}
                    content={contentAlert}
                    changeAlert={changeAlert}
                />
            )}
        </>
    );
};

export default Root;
